//clear local storage on logout
jQuery(document).ready(function()
{
    jQuery(".logout-btn").click(function(event){
        event.preventDefault();
        window.localStorage.clear();
        window.location.href ='/index.php/user/sign_out';
    });
});
